import React, { useEffect, useState } from "react";
import "./LeadSearchModal.scss";
import { maskNumber } from "./slashRtc";
import Input from "./common/Input";
import Button from "./common/Button";
function LeadSearchModal({ data, closeModal, getOnCallLeadFn, hideTimer }) {
  const [showResult, setShowResult] = useState(false);
  const [counter, setCounter] = useState(5);
  const [searchData, setSearchData] = useState({
    emailAddress: null,
    phoneNumber: null,
    leadName: null,
    leadRefId: null,
  });
  const handleSearch = () => {
    getOnCallLeadFn(searchData);
  };

  useEffect(() => {
    if (hideTimer) {
      setShowResult(true);
    } else {
      const timer = setTimeout(() => {
        setShowResult(true);
      }, 5000);

      const interval = setInterval(() => {
        setCounter((prevCount) => {
          if (prevCount === 0) {
            clearInterval(interval);
            return 0;
          } else {
            return prevCount - 1;
          }
        });
      }, 1000);

      return () => {
        clearInterval(interval);
        clearTimeout(timer);
      };
    }
  }, []);
  return (
    <div styleName="base">
      <div styleName="title-container">
        <div styleName="title">Search Lead</div>
      </div>

      {!showResult && <div>Searching incoming call lead...({counter})</div>}

      {showResult && data && (
        <div>
          {" "}
          {`No lead exists with 
          ${data?.leadName ? `name - ${data?.leadName},` : ""}
          ${data?.emailAddress ? `email-${data?.emailAddress},` : ""}
          ${data?.leadRefId ? `refId-${data?.leadRefId},` : ""}
          ${data?.phoneNumber ? `number-${maskNumber(data?.phoneNumber)}` : ""}
  `}
        </div>
      )}
      {showResult && (
        <div styleName="body-container">
          {data && <p>Find lead with other parameters:-</p>}
          <div styleName="input-holder">
            <div styleName="input">
              <Input
                value={searchData?.leadName}
                onChange={(val) =>
                  setSearchData((previous) => {
                    return {
                      ...previous,
                      leadName: val,
                    };
                  })
                }
                placeholder="Lead name"
              />
            </div>

            <div styleName="input">
              <Input
                value={searchData?.leadRefId}
                onChange={(val) =>
                  setSearchData((previous) => {
                    return {
                      ...previous,
                      leadRefId: val,
                    };
                  })
                }
                placeholder="Lead RefId"
              />
            </div>

            <div styleName="input">
              <Input
                value={searchData?.emailAddress}
                onChange={(val) =>
                  setSearchData((previous) => {
                    return {
                      ...previous,
                      emailAddress: val,
                    };
                  })
                }
                placeholder="Contact email"
              />
            </div>

            <div styleName="input">
              <Input
                value={searchData?.phoneNumber}
                onChange={(val) =>
                  setSearchData((previous) => {
                    return {
                      ...previous,
                      phoneNumber: val,
                    };
                  })
                }
                placeholder="Alternative phone No."
              />
            </div>
          </div>
        </div>
      )}

      <div styleName="footer-container">
        <Button label="Close" onClick={closeModal} />
        {showResult && <Button label="Search" onClick={handleSearch} />}
      </div>
    </div>
  );
}

export default LeadSearchModal;
